export * from './RoundedItem.styles'

export { default } from './RoundedItem'
